import React from "react";
import { Button, Container, Typography } from "@mui/material";
import { AppDialog } from "@/components/common";

const DemoDialog = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container>
      <Button variant="outlined" onClick={handleClickOpen} sx={{ width: 200 }}>
        Open App Dialog
      </Button>
      <AppDialog
        open={open}
        title="This is title"
        onClose={handleClose}
        ConfirmButtonProps={{
          label: "Xác nhận",
          onClick: () => console.warn("confirm"),
        }}
      >
        <Typography>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
          Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Praesent commodo cursus magna, vel scelerisque
          nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia
          bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed
          odio dui. Donec ullamcorper nulla non metus auctor fringilla.
        </Typography>
      </AppDialog>
    </Container>
  );
};

export default DemoDialog;
